/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Province_UnknownInputs */

const vi_report_province_unknown = /** @type {(inputs: Report_Province_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không xác định`)
};

/**

* @param {Report_Province_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_province_unknown = /** @type {((inputs?: Report_Province_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Province_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_province_unknown(inputs)
});